export const GOOGLE_MAP_API_KEY = "AIzaSyBQmVJgzxh49P-gpZZ144ovtcsS8Y6qGKc";
